import { get } from "@utils/axios";

export const getDashboardDataReq = () => {
  return get("admin-management/get-admin-dashboard");
}